import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  page: string;

  public static CHAPVEST_API_URL = "https://node-backend.chapwood.apps.savantly.cloud/";
  // public static CHAPVEST_API_URL = "http://localhost:3000/";
  public static CHAPTIMIZER_API_URL = "https://chapwood-optimizer.chapwood.apps.savantly.cloud/";
  // public static CHAPTIMIZER_API_URL = "http://127.0.0.1:5002/";

  constructor(public http: HttpClient) {
    this.page = '';
  }

   /** ======================================== BUILDERS REST API ================================================== */
  /**
   * Makes a GET request for all builder
   */
  getBuilders(){
    return this.http.get(CalculationService.CHAPVEST_API_URL);
  }
  /**
   * Makes a GET request for a specific builder
   * This method patches the associated statistic as well
   * @param id The id of the builder
   */
  getBuilder(id){
      var url = CalculationService.CHAPVEST_API_URL + id;
      return this.http.get(url);
  }
  /**
   * Makes a POST request for an builder creating a new builder
   * @param newBuilder  The body of the request for an builder/The new builder object to be added
   */
  addBuilder(newBuilder){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      // headers.append('Content-Type', 'application/json');
      return this.http.post(CalculationService.CHAPVEST_API_URL +'builders', newBuilder, {headers: headers});
  }
  /**
   * Makes a PATCH request for an existing builder
   * @param id The id of the builder to be edited
   * @param body  The body of the request for an builder
   */
  editBuilder(id, body){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      headers.keys
      return this.http.patch(CalculationService.CHAPVEST_API_URL +'builders/' + id, body);
  }
  /**
   * Makes a DELETE request for a specific builder
   * @param id The id of the builder to be deleted
   */
  deleteBuilder(id){
      return this.http.delete(CalculationService.CHAPVEST_API_URL +'builders/' + id);
  }

  getCaptureRatio(){
    return CalculationService.CHAPTIMIZER_API_URL + 'capture_ratio';
  }

  getCaptureRatioCSV(){
    return CalculationService.CHAPTIMIZER_API_URL + 'capture_ratio_csv';
  }

  getPDFURL()
  {
    return CalculationService.CHAPTIMIZER_API_URL + 'portfoliobuilderPDF';
  }
}
